import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
    draw?: boolean
}

interface LogoProps {
    className?: string
}

/*
 * The arched window mark. With `draw`, its lines draw themselves in once a
 * .reveal ancestor is shown (see .logo-draw in globals.css).
 */
export const LogoMark: FC<LogoMarkProps> = ({ className, draw = false }): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.4}
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            className={cn('size-6 shrink-0', draw && 'logo-draw', className)}
        >
            <path pathLength={1} d='M5.75 20.25V10a6.25 6.25 0 0 1 12.5 0v10.25' />
            <path pathLength={1} d='M3.75 20.25h16.5' />
            <path pathLength={1} d='M12 3.75v16.5' />
            <path pathLength={1} d='M5.75 12.75h12.5' />
        </svg>
    )
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-1.5 text-foreground', className)}>
            <LogoMark className='size-[26px] -translate-y-px transition-[rotate] duration-500 ease-out group-hover:-rotate-[8deg]' />

            <span className='font-heading text-[2.05rem] leading-none tracking-[-0.03em] italic'>
                Closewell
            </span>
        </span>
    )
}
